export const PTO_STATUS = {
  approvalNeeded: 'ApprovalNeeded',
  approved: 'Approved',
  booked: 'Booked',
  cancelled: 'Cancelled',
  expired: 'Expired',
  pendingApproval: 'PendingApproval',
  rejected: 'Rejected',
  scheduled: 'Scheduled',
};

export const PTO_DIALOGUE_TYPES = {
  accept: 'accept',
  cancel: 'cancel',
  reject: 'reject',
};

export const OLD_FUTURE_TRANSFER_DATE_MSG = 'Transfer date is in the future';
export const FUTURE_TRANSFER_DATE_MSG = 'The Product Transfer Order date has not yet arrived.';

export const ReconsignmentMessage =
  'Maximize efficiencies with Reconsignment Control by limiting loading of transferred barrels to the current terminal location or a location farther from the origin.';

export const RestrictedLocationsWarning =
  '"There are no reconsignable locations between this origin and the transfer location. If you want to restrict reconsignment on this transfer order, return to the previous step and remove this Origin to continue."';

export const INVENTORY_SORT_ORDER = [
  'ANYINVENTORY',
  'ANYAVAILABLE',
  'ANYINTRANSIT',
  'ANYUNCONTROLLED',
  'UNCONTROLLEDAVAILABLE',
  'UNCONTROLLEDINTRANSIT',
  'ANYCONTROLLED',
  'CONTROLLEDAVAILABLE',
  'CONTROLLEDINTRANSIT',
];

export const SEARCH_STATUS = {
  all: 'all',
  allClosed: 'allClosed',
  allOpen: 'allOpen',
  approvalNeeded: 'approvalNeeded',
  approved: 'approved',
  booked: 'booked',
  cancelled: 'cancelled',
  expired: 'expired',
  pendingApproval: 'pendingApproval',
  rejected: 'rejected',
  scheduled: 'scheduled',
};

export const SEARCH_STATUS_OPTIONS = [
  { label: 'All', value: SEARCH_STATUS.all },
  { label: 'All Open', value: SEARCH_STATUS.allOpen },
  { label: 'All Closed', value: SEARCH_STATUS.allClosed },
  { label: 'Needs My Approval', value: SEARCH_STATUS.approvalNeeded },
  { label: 'Needs Recipient Approval', value: SEARCH_STATUS.pendingApproval },
  { label: 'Cannot Book', value: SEARCH_STATUS.approved },
  { label: 'Scheduled', value: SEARCH_STATUS.scheduled },
  { label: 'Recipient Rejected', value: SEARCH_STATUS.rejected },
  { label: 'Canceled', value: SEARCH_STATUS.cancelled },
  { label: 'Expired', value: SEARCH_STATUS.expired },
  { label: 'Booked', value: SEARCH_STATUS.booked },
];
